import axios from 'axios';
import { getAccessToken } from '../services/authService';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    withCredentials: false,
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    },

});

api.interceptors.request.use(
    async function (config) {
        try {
            config.headers['Authorization'] = `Bearer ${await getAccessToken()}`;
        } catch (error) {
            console.error('Could not obtain access token', error);
        }
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

let setIsAuthorized: ((value: boolean) => void) | null = null;

export const setAuthorizationSetter = (setter: (value: boolean) => void) => {
    setIsAuthorized = setter;
};

api.interceptors.response.use(
    function (response) {
        return response;
    },
    function (error) {
        switch (error.code) {
            case 'ECONNABORTED':
            case 'ERR_NETWORK':
                console.error('Connection error with the server');
                break;
        }
        switch (error.response?.status) {
            case 401:
                if (setIsAuthorized) {
                    setIsAuthorized(false);
                }
                console.info('Unauthorized');
                break;
        }
        return Promise.reject(error);
    }
);

export default api;
